export type TruncateOptions = {
  length: number;
  separator?: string;
  ellipsis?: string;
};

function truncate(text: string, options: TruncateOptions): string {
  const { length, separator = " ", ellipsis = "..." } = options;
  let truncatedText = text;

  // Truncate by word boundary
  if (truncatedText.length > length) {
    const words = truncatedText.split(separator);
    let truncatedWords = words.slice(0, Math.max(1, words.length - 1));
    while (truncatedWords.join(separator).length + ellipsis.length > length) {
      truncatedWords.pop();
    }
    truncatedText = truncatedWords.join(separator) + ellipsis;
  }

  return truncatedText;
}

export default truncate;
